var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { updateJasBoardsVerificationHistoryFunctionDef } from '../../../../backend/config/classifiers/platform-functions/updateJasBoardsVerificationHistory';
import { jasBoardsStatusViewName } from '../../../../backend/config/classifiers/views/jas-boards-status/view';
import { useCredentialingTranslation } from '../../../../ui/hooks';
import { DataTable } from '@juvare/common-data-table-ui/DataTable';
import { handleErrorSnackbar, showAlertSnackbar } from '@juvare/common-web-ui/SnackbarHelper';
import { useTypedPlatformFunction } from '@juvare/platform-sdk-react/ui/features/typed-platform-functions';
import { useViewDataTable } from '@juvare/platform-sdk-react/ui/hooks';
import UpdateIcon from '@mui/icons-material/Update';
import { Box } from '@mui/material';
import React from 'react';
import { useJasBoardsStatusColumns } from '../hooks/useJasBoardsStatusColumns';
export default function JasBoardsStatusTable() {
    const { t } = useCredentialingTranslation();
    const [updating, setUpdating] = React.useState(false);
    const updateJasBoardsVerificationHistory = useTypedPlatformFunction(updateJasBoardsVerificationHistoryFunctionDef);
    const { columns } = useJasBoardsStatusColumns();
    const { dataTableProps, reload } = useViewDataTable({
        viewName: jasBoardsStatusViewName,
        columns,
        defaultSortColumnKey: 'name',
        filterConfig: {},
        mapViewFilterData: () => [],
        title: t('table.jasBoardStatusHistory.title'),
        tableSx: { tableLayout: 'fixed' },
    }, {});
    const handleUpdateAll = () => __awaiter(this, void 0, void 0, function* () {
        setUpdating(true);
        try {
            const { data } = yield updateJasBoardsVerificationHistory({});
            if (data.success) {
                reload();
                showAlertSnackbar({
                    type: 'success',
                    message: t('table.jasBoardStatusHistory.alerts.rechecked'),
                    horizontalPosition: 'right',
                    autoHideDuration: 3000,
                });
            }
        }
        catch (error) {
            handleErrorSnackbar(error);
        }
        setUpdating(false);
    });
    return (React.createElement(Box, { p: 4 },
        React.createElement(DataTable, Object.assign({}, dataTableProps, { mainAction: {
                onClick: handleUpdateAll,
                label: t('table.jasBoardStatusHistory.labels.updateStatus'),
                icon: React.createElement(UpdateIcon, null),
                disabled: updating,
            } }))));
}
